import { useMemo, useRef } from 'react';
import { useAuth } from '../../utils/Auth';
import Menu from './Menu';
import { useNavigate } from 'react-router-dom';
import LogoDark from '../Images/LiquidQR-dark.png';
import { useClickOutside } from '../../utils/hooks/useClickOutside';
import OrganizationSelector from '../OrganizationSelector';
import styles from './Navigation.module.css';

export default function Navigation() {
  // ----- STATE INITIALIZATION -----
  const { currentUser, logout, isLoading } = useAuth();

  const menuBtnRef = useRef(null);
  const [menuRef, showMenu, setShowMenu] = useClickOutside(false, menuBtnRef);
  const email = useMemo(() => !isLoading ? currentUser?.email : '', [currentUser?.email, isLoading]);

  const navigate = useNavigate();
  // ----- END STATE INITIALIZATION -----

  // ----- LOGOUT FUNCTION -----
  const handleLogout = async () => {
    try {
      await logout();
      navigate(`/auth?mode=login`, { replace: true });
    } catch (error) {
      console.error("Error on handleLogout in Navigation: ", error.message || "");
    };
  };
  // ----- END LOGOUT FUNCTION -----

  const navState = useMemo(() => {
    if (!email || isLoading) return <></>;

    return (
      <>
        <div className={styles.userContainer}>
          <div className={styles.username}>
            <OrganizationSelector />
            <button className={styles.orgBtn} onClick={() => navigate('/organizations')} title='Organization Dashboard'>
              <i className='fas fa-users' style={{ pointerEvents: 'none' }} />
            </button>
          </div>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.navBtnWrap}>
          <button type='button' className={styles.navBtn} onClick={() => window.open(`https://liquidqr.com/store`, '_blank')}>
            <i className='fa-solid fa-store' />
          </button>
          <button type='button' className={styles.navBtn} onClick={() => navigate('/settings')}>
            <i className='fas fa-gear' />
          </button>
          <button type='button' className={styles.navBtn} onClick={handleLogout}>
            <i className='fas fa-arrow-right-from-bracket' />
          </button>
        </div>
      </>
    );
  }, [email, isLoading]);

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.left}>
            <button type='button' className={styles.menuBtn} onClick={() => setShowMenu(!showMenu)} ref={menuBtnRef}>
              {/* add motion svg */}
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6H20" stroke="#161d2d" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 12H20" stroke="#161d2d" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 18H20" stroke="#161d2d" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button type='button' className={styles.logoBtn} onClick={() => navigate('/')}>
              <img src={LogoDark} width='100%' height='auto' alt='Dark Logo' />
            </button>
          </div>
          <div className={styles.right}>
            {navState}
          </div>
        </div>
      </div>
      <Menu ref={menuRef} showMenu={showMenu} setShowMenu={setShowMenu} handleLogout={handleLogout} />
    </>
  );
};